// src/environment/environment.js
const browserHostname =
  typeof window === "undefined" ? "localhost" : window.location.hostname;
const isLocalRuntime = ["localhost", "127.0.0.1", "::1"].includes(
  browserHostname
);

const indexApiBaseUrl =
  process.env.REACT_APP_INDEX_API_BASE_URL ||
  (isLocalRuntime
    ? "http://localhost:1000"
    : "https://indexapi.noptionwave.com");
const stockApiBaseUrl =
  process.env.REACT_APP_STOCK_API_BASE_URL ||
  (isLocalRuntime
    ? "http://localhost:2000"
    : "https://stockapi.noptionwave.com");
const cryptoApiBaseUrl =
  process.env.REACT_APP_CRYPTO_API_BASE_URL ||
  (isLocalRuntime
    ? "http://localhost:4000"
    : "https://cryptoapi.noptionwave.com");
const executionRiskApiRootPath =
  process.env.REACT_APP_EXECUTION_RISK_API_ROOT_PATH ||
  "/api/algotrade/execution-risk";
const executionRiskApiBaseUrl =
  process.env.REACT_APP_EXECUTION_RISK_API_BASE_URL ||
  `${stockApiBaseUrl.replace(/\/$/, "")}/${executionRiskApiRootPath.replace(/^\//, "")}`;
const userSchedulerPresenceBaseUrl =
  process.env.REACT_APP_USER_SCHEDULER_PRESENCE_BASE_URL ||
  `${stockApiBaseUrl.replace(/\/$/, "")}/api/algotrade/user-scheduler`;

export const environment = {
  production: !isLocalRuntime,

  indexApiTopic: "/index-api-topic",
  optionData: "/index-option-data",
  stoackApiTopic: "/stock-api-topic",
  stockDayRangeDataTopic: "/stock-day-range-topic",
  stockDataAnalysisTopic: "/stock-analysis-topic",
  cryptoApiTopic: "/crypto-api-topic/option-data",
  stockSectorTopic: "/stock-sector-topic",
  nseWebsiteOIResposneDataTopic: "/nse-website-oi-response-data-topic",
  sectorIndicestopic: "/sector-indices-topic",
  strategyIndiciesTopic: "/strategy-indices-topic",
  globalMarketDataTopic: "/global-market-data-topic",
  fiiDiiDataTopic: "/fii-dii-data-topic",
  foTopGainerLooserTopic: "/fo-top-gainer-looser-topic",
  blockDealsLargeStockTopic: "/block-deals-large-stock-topic",
  blockDealsTopStockTopic: "/block-deals-top-stock-topic",
  logicalIndicatorValueTopic: "/logical-indicator-value-topic",
  blockDealsTopStockByDate: "/bdlts/get-bdlts-by-date",
  buyerSellerStockTopic: "/buyer-seller-stock-topic",
  stockScannerTopic: "/stock-scanner-topic",
  atlasScannerTopic: "/atlas-scanner-topic",
  positionalStockSignalsUrl: "/positional-stock/signals",
  positionalStockDailyLevelsUrl: "/positional-stock/daily-levels",
  stockOptionTopic: "/stock-option-topic",
  stockPreOpenDataTopic: "/stock-pre-open-data-topic",
  upstoxOtmOptionPremiumTopic: "/upstox-otm-option-premium",
  indexGreeksAnalyseTopic: "/index-greeks-analyse-topic",
  angelOneGreeksTopic:
    process.env.REACT_APP_ANGEL_ONE_GREEKS_TOPIC ||
    "/index-api-topic/angelone-greeks",
  angelOneGreeksHistoryTopic:
    process.env.REACT_APP_ANGEL_ONE_GREEKS_HISTORY_TOPIC ||
    "/user/queue/angelone-greeks-history",
  angelOneGreeksHistoryRequestDestination:
    process.env.REACT_APP_ANGEL_ONE_GREEKS_HISTORY_REQUEST_DESTINATION ||
    "/app/angelone-greeks/history",
  angelOneGammaBlastEventsUrl:
    process.env.REACT_APP_ANGEL_ONE_GAMMA_BLAST_EVENTS_URL ||
    `${indexApiBaseUrl}/angelone/greeks/gamma-blast/events`,
  angelOneGammaBlastStatsUrl:
    process.env.REACT_APP_ANGEL_ONE_GAMMA_BLAST_STATS_URL ||
    `${indexApiBaseUrl}/angelone/greeks/gamma-blast/stats`,
  angelOneGammaBlastLatestUrl:
    process.env.REACT_APP_ANGEL_ONE_GAMMA_BLAST_LATEST_URL ||
    `${indexApiBaseUrl}/angelone/greeks/gamma-blast/latest`,
  angelOneGammaBlastPremiumMapHistoryUrl:
    process.env.REACT_APP_ANGEL_ONE_GAMMA_BLAST_PREMIUM_MAP_HISTORY_URL ||
    `${indexApiBaseUrl}/angelone/greeks/gamma-blast/premium-map-history`,
  angelOneRuntimeMarketDataUrl:
    process.env.REACT_APP_ANGEL_ONE_RUNTIME_MARKET_DATA_URL ||
    `${indexApiBaseUrl}/angelone/market-data/runtime`,
  angelOneLoginUrl:
    process.env.REACT_APP_ANGEL_ONE_LOGIN_URL ||
    `${indexApiBaseUrl}/angelone/login`,
  angelOneAccessTokensUrl:
    process.env.REACT_APP_ANGEL_ONE_ACCESS_TOKENS_URL ||
    `${indexApiBaseUrl}/angelone/access-tokens`,
  sectorRsiBandScannerTopic: "/sector-rsi-band-scanner-topic",
  sectorStrategiesTopic: "/sector-strategies-topic",
  brokerOrderDestination: "/user/queue/order-details",
  brokerPositionDestination: "/user/queue/position-details",
  sectorStrategyExecutionDestination: "/user/queue/sector-strategy-executions",

  baseUrl: indexApiBaseUrl,
  stockApiBaseUrl,
  userSchedulerPresenceBaseUrl,
  executionRiskApiBaseUrl,
  executionRiskSaveUrl:
    process.env.REACT_APP_EXECUTION_RISK_SAVE_URL ||
    "/save-execution-risk",
  executionRiskGetAllUrl:
    process.env.REACT_APP_EXECUTION_RISK_GET_ALL_URL ||
    "/get-all-execution-risk",
  executionRiskGetByIdUrl:
    process.env.REACT_APP_EXECUTION_RISK_GET_BY_ID_URL ||
    "/get-execution-risk-by-id",
  executionRiskUpdateUrl:
    process.env.REACT_APP_EXECUTION_RISK_UPDATE_URL ||
    "/update-execution-risk",
  executionRiskDeleteUrl:
    process.env.REACT_APP_EXECUTION_RISK_DELETE_URL ||
    "/delete-execution-risk",
  niftyWebsocketUrl:
    process.env.REACT_APP_INDEX_API_WEBSOCKET_URL ||
    `${indexApiBaseUrl}/index-api-ws-data`,
  angelOneGreeksWebsocketUrl:
    process.env.REACT_APP_ANGEL_ONE_GREEKS_WEBSOCKET_URL ||
    `${indexApiBaseUrl}/angelone-greeks-ws`,
  stockApiDayRangeDataWSUrl:
    process.env.REACT_APP_STOCK_API_WEBSOCKET_URL ||
    `${stockApiBaseUrl}/stock-api-ws`,
  cryptoApiWSUrl:
    process.env.REACT_APP_CRYPTO_API_WEBSOCKET_URL ||
    `${cryptoApiBaseUrl}/crypto-api-ws`,
};
